import React, { useEffect, useState } from 'react'
import {
    seeContentSaved, removeContentSaved,
    changeSellerRating, updateClassified, getSellerRating, saveContent,
    seeArchivedStoryHome, deleteStoryHome, unArchiveStorySave
} from '../../actions/userActions';
import { connect } from 'react-redux'
import { Translate } from '../../language';
import inMemoryJWT from '../../auth/inMemoryJwt';
import MasoryPost from '../../containers/Post/MasoryPost/MasoryPost';
import Options from '../../utils/components/Options/Options';

const MySaved = ({ seeArchivedStoryHome, unArchiveStorySave, isLoadingArchivedStoriesList, archivedStoriesList, isLoadingListPostSaved, listPostSaved, removeContentSaved, seeContentSaved, history }) => {

    const [isModalOpenInvalidate, setIsModalOpenInvalidate] = useState(false)

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeArchivedStoryHome()
            seeContentSaved({
                limit: 5,
                skip: 0,
                contentType: "post",
            }, 'post')
            /* seeContentSaved({
                entityID: localStorage().getItem('idUser'),
                typeContent: "classified"
            }, 'classifieds') */
        })

    }, [])




    return (
        <div className="scroll-menu container-page">
            {!isLoadingListPostSaved && listPostSaved.length > 0 && <div className='title-saved-post'>Publicaciones</div>}
            {!isLoadingListPostSaved && <MasoryPost type="profile" linkPath={"/Post/"} masoryPost={listPostSaved.map(ps => { return { ...ps.postID, _idS: ps._id } })} />
            }
            {!isLoadingArchivedStoriesList && archivedStoriesList.length > 0 && <div className='title-saved-post'>Historias</div>}
            <div className="content-list-social">
                {!isLoadingArchivedStoriesList && archivedStoriesList.map(story => (
                    <div className='content-card-list'>
                        <div className='column m-1'>
                            <Options
                                style={{
                                    position: "initial",
                                    width: "initial"
                                }}

                                options={[
                                    {

                                        text: Translate('delete', 'es'), onClick: (e) => {
                                            e.preventDefault(); e.stopPropagation();

                                        }

                                    }
                                ]} />
                        </div>

                        {
                            story.multimedia[0].type.includes("image") && <img width="100%" src={story.multimedia[0].url.origin} />
                        }


                        {
                            story.multimedia[0].type === "video" && (
                                <video preload="auto" className="video-post-view" controls>
                                    <source src={story.multimedia[0].url.origin}></source>
                                </video>
                            )
                        }



                    </div>
                ))
                }
            </div>

        </div>

    )
}
const mapStateToProps = (state) => {
    return {
        isLoadingListClassifiedSaved: state.userInfo.isLoadingListClassifiedSaved,
        listClassifiedSaved: state.userInfo.listClassifiedSaved,
        isLoadingListPostSaved: state.userInfo.isLoadingListPostSaved,
        listPostSaved: state.userInfo.listPostSaved,
        isLoadingSellerRate: state.userInfo.isLoadingSellerRate,
        sellerRate: state.userInfo.sellerRate,
        isLoadingArchivedStoriesList: state.userInfo.isLoadingArchivedStoriesList,
        archivedStoriesList: state.userInfo.archivedStoriesList
    }
}
export default connect(mapStateToProps, { seeContentSaved, seeArchivedStoryHome, unArchiveStorySave, deleteStoryHome, removeContentSaved, getSellerRating, saveContent, updateClassified, changeSellerRating })(MySaved)
